import React from "react";
import { Link } from "react-router-dom";
import Brand from "./Brand";
import MedicalCareBadge from "./MedicalCareBadge";
import { Mail, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 border-t border-[rgba(157,252,4,0.18)] mt-24 bg-[rgba(3,8,5,0.72)] backdrop-blur-md"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div className="md:col-span-2">
            <Brand size="md" />
            <p className="mt-5 max-w-md text-[color:var(--ss-muted)] text-base leading-relaxed">
              AI-powered agricultural intelligence for operators across every
              vertical. Product recognition, composition insights, quality
              assessment, and batch tracking — all in one enterprise-grade
              platform.
            </p>

            <div className="mt-6 flex items-center gap-5 text-sm">
              <a
                href="mailto:info@strainscanpro.com"
                className="flex items-center gap-2 text-[color:var(--ss-green)] hover:text-white transition"
                data-testid="footer-email"
              >
                <Mail size={16} /> info@strainscanpro.com
              </a>
              <a
                href="https://www.strainscanpro.com"
                className="flex items-center gap-2 text-[color:var(--ss-muted)] hover:text-[color:var(--ss-green)] transition"
              >
                <Globe size={16} /> www.strainscanpro.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-display tracking-[0.28em] text-[color:var(--ss-green)] mb-4">
              COMPANY
            </h4>
            <ul className="space-y-2 text-[color:var(--ss-text)]">
              <li><Link to="/about" className="hover:text-[color:var(--ss-green)]">About</Link></li>
              <li><Link to="/contact" className="hover:text-[color:var(--ss-green)]">Contact</Link></li>
              <li><a href="mailto:info@strainscanpro.com" className="hover:text-[color:var(--ss-green)]">Request Demo</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-[rgba(157,252,4,0.14)] pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="text-xs font-display tracking-[0.36em] text-[color:var(--ss-muted)]">
            ENTERPRISE-LEVEL PROPRIETARY SOFTWARE
          </div>
          <MedicalCareBadge />
        </div>

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[color:var(--ss-muted)] font-mono">
          <div>© {new Date().getFullYear()} StrainScan Pro. All rights reserved.</div>
          <div className="tracking-[0.3em]">OTC TICKER: MDCE</div>
        </div>
      </div>
    </footer>
  );
}
